var _excluded = ["children", "component", "position"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import styles from './use_styles';
import useDirection from '../direction/use_direction';
import { jsx as ___EmotionJSX } from "@emotion/core";
var LEFT_POSITION = 'left';
var RIGHT_POSITION = 'right';
var NotificationBadge = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  var {
      children,
      component: Component = 'span',
      position: positionProp = 'top-end'
    } = _ref,
    other = _objectWithoutProperties(_ref, _excluded);
  var {
    isRTL
  } = useDirection();
  var [verticalPosition, horizontalPosition] = positionProp.split('-');
  var mapHorizontalPosition = {
    left: isRTL ? RIGHT_POSITION : LEFT_POSITION,
    start: LEFT_POSITION,
    right: isRTL ? LEFT_POSITION : RIGHT_POSITION,
    end: RIGHT_POSITION
  };
  var style = styles({
    horizontal: mapHorizontalPosition[horizontalPosition],
    vertical: verticalPosition
  });
  return ___EmotionJSX(Component, _extends({}, other, {
    css: style.root,
    ref: ref
  }), children, ___EmotionJSX("span", {
    css: style.badge
  }));
});
NotificationBadge.displayName = 'NotificationBadge';
export default NotificationBadge;